<template>
  <div :style="getRiskStyle(riskRating, true)">
    <RiskRatingDefinition :riskCategoryInfo="getRiskCategoryInfo(riskRating)">
      <div
        :style="getRiskStyle(riskRating)"
        class="hyp-risk-icon cursor-pointer pull-left mt-1 mx-1"
      ></div>
    </RiskRatingDefinition>
    <div class="pull-left hyp-risk-type">
      {{ riskRating.riskCategoryNameDisplay }}:
    </div>
    <div class="pull-left pr-6 pl-1">
      {{ getRiskLevel(riskRating) }}
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";

import { RISK_LEVELS } from "@/common/constants/controlRisks/risks";

export default {
  name: "RiskRating",
  components: {
    RiskRatingDefinition: () =>
      import("@/components/controlRisks/risks/RiskRatingDefinition"),
  },
  props: {
    riskRating: {
      type: Object,
    },
  },
  methods: {
    getRiskCategoryInfo(risk) {
      return {
        riskCategoryId: this.riskRating.riskCategoryId,
        riskValue: risk.value ? risk.value : risk.rateValue,
        riskCategoryNameDisplay: this.riskRating.riskCategoryNameDisplay,
      };
    },
    getRiskLevel(risk) {
      if (risk && risk.rateValue) {
        const rating = lodashFind(RISK_LEVELS, ["value", risk.rateValue]);
        return lodashGet(rating, "name");
      }
      return null;
    },
    getRiskStyle(risk, boxStyle) {
      let isSameAsParent = false;
      const id = risk.riskCategoryId;
      const level = risk.rateValue;
      for (
        let i = 0;
        this.parentRatings && i < this.parentRatings.length;
        i++
      ) {
        const checkLevel = this.parentRatings[i].rateValue;
        const checkId = this.parentRatings[i].riskCategoryId;
        if (id === checkId && level === checkLevel) {
          isSameAsParent = true;
        }
      }

      if (risk && risk.rateValue) {
        const rating = lodashFind(RISK_LEVELS, ["value", risk.rateValue]);
        const color = isSameAsParent ? "#CBCBCB" : lodashGet(rating, "bgColor");
        if (boxStyle) {
          return {};
        }
        return {
          "background-color": color,
          height: "14px",
          width: "14px",
        };
      }
      return null;
    },
  },
};
</script>

<style scoped>
.hyp-risk-icon {
  width: 100%;
  border-radius: 10px;
}
.hyp-risk-type {
  text-transform: capitalize;
}
</style>
